module.exports = __webpack_public_path__ + "static/media/1_Pokana_20150626.6af170f3.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2015/1_Pokana_20150626.pdf
// module id = 184
// module chunks = 0